import { createApp } from 'vue';

import { setupIcons } from '@silae/composables';

import App from './App.vue';
import { i18n, kitLibrary, setupLogger, setupNotifications, setupSentry, vuetify } from './plugins';
import { router } from './router';
// import { setupErrorHandler } from './services';
import { pinia } from './stores';
import './style';

setupLogger();

const app = createApp(App);

// setup Sentry as early as possible
setupSentry(app);
// setupErrorHandler(app);

app.use(pinia);
app.use(router);
app.use(vuetify);
app.use(i18n);

setupIcons(app, kitLibrary);
setupNotifications(app);

app.mount('#app');
